import { SERVER_ORIGIN } from './config'

// Create base settings for fetch requests
const defaultOptions = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
}

// API wrapper for making HTTP requests
const api = {
  async get(url) {
    const response = await fetch(`${SERVER_ORIGIN}${url}`, {
      ...defaultOptions,
      method: 'GET'
    })
    
    if (response.status === 401) {
      window.location.href = '/login'
      throw new Error('Unauthorized')
    }
    
    return { data: await response.json() }
  },
  
  async post(url, data) {
    const response = await fetch(`${SERVER_ORIGIN}${url}`, {
      ...defaultOptions,
      method: 'POST',
      body: JSON.stringify(data)
    })
    
    if (response.status === 401) {
      window.location.href = '/login'
      throw new Error('Unauthorized')
    }
    
    return { data: await response.json() }
  }
}

export default api 